import React, { useState } from 'react';
import { TextArea, Dropdown, Checkbox, Label, Input, Form, Icon } from 'semantic-ui-react';
import { DateTimeInput, DateInput } from 'semantic-ui-calendar-react';
import { getBackgroundColour, getTextColour } from '../../helpers/colours';
import currency from 'currency.js';
import moment from 'moment';
import { prettyMoney, uglyMoney } from '../../helpers/currency';
import { UIDateFormat } from '../../config/dates';
import TextInput from './TextInput';

class Option extends React.Component {

  handleListChange = (value) => {
    const selection = this.props.option.data.find(x => x.id === value)
    const option = {...this.props.option, defaultList: {...selection} };
    this.props.onChange(option, value)
  }

  handleMoneyChange = (value) => {
    const isValid = /^[\d.]+$/.test(value) || value.length < 1

    if (isValid) {
      this.handleTextChange(value);
    }
  }

  handleTextChange = async (value, updateAttribute = 'defaultText') => {
    const { option } = this.props;
    let update = true;
    let isValid = true;

    if (value.length > option.maxLength && option.maxLength > 0) update = false;

    if (update && option.entryPattern && value.length > 0) {
      const { allowedCharacterRegex, appends } = option.entryPattern
      const regex = new RegExp(allowedCharacterRegex)
      const lastCharacter = value.slice(-1)

      if (Option.getValue(option).length < value.length) {
        update = regex.test(lastCharacter) || lastCharacter === "-"
        const appendedCharacter = appends.find(x => x.position === value.length)
        if (appendedCharacter) {
          value += appendedCharacter.text;
        }
      }
    }

    if (update) {
      if (option.regex && value.length) {
        const regex = new RegExp(option.regex)
        isValid = regex.test(value)
      } 
      if (isValid && option.checkDenom > 0) {
        isValid = (currency(value) * 1000) % (option.checkDenom * 1000) === 0;
      }

      await this.props.onChange({...this.props.option, isValid, [updateAttribute]: value }, value);
    } 
  }

  handleCheckboxChange = (option) => {
    const value = option.defaultText.toLowerCase() === "true" ? "false" : "true"
    this.props.onChange({...option, defaultText: value}, value)
  }

  static getValue = (option) => {
    switch (option.type) {

      case 1: // List (tested)
        return (option.defaultList && option.defaultList.id) ? option.defaultList.id : ""
   
      case 3:
      case 5:
        return option.defaultDate || "";

      default:
        return option.defaultText || ""
    }
  }

  renderError = () => this.props.option.isValid === false && <small class="optionError">Invalid {this.props.option.text}</small> 

  handleMoneyBlur = (event) => { 
      this.prettifyMoney(event.target.value) 
  }

  handleMoneyFocus = (event) => {
    event.persist();
    this.handleTextChange(uglyMoney(event.target.value)).then(() => {
      this.setState({ type: "number" }, () => {
        event.target.select();
      })
    });
  }

  prettifyMoney = (value) => {
    if (!isNaN(value))
      this.handleTextChange(prettyMoney(value))
  }

  render() {

    const { option } = this.props;
    const error = option.isValid === false;

    switch (option.type) {

      case 1: // List (tested)
        const options = option.data.length ? option.data.map((option, index) => { return { ...option, value: option.id, key: `${option.text} ${index}` } }) : []
        return <Dropdown
          selection
          options={options}
          value={Option.getValue(option)}
          onChange={(event, {value}) => this.handleListChange(value)}
          tabIndex={this.props.tabIndex}
          disabled={!option.isEditable}
          placeholder={option.placeHolder}
          fluid={!this.props.inline}
          error={error}
        />

      case 2: // Text
        return <Form.Field error={error}>
          <TextInput 
            option={option}
            onChange={this.handleTextChange} 
            tabIndex={this.props.tabIndex} 
            error={error} 
          />
          {this.renderError()}
        </Form.Field>

      case 3: // Date
        return (
          <>
            <DateInput
              name="startDate"
              value={moment(Option.getValue(option))}
              iconPosition="left"
              onChange={(event, {value}) => this.handleTextChange(moment(value, UIDateFormat).toISOString(), 'defaultDate')}
              readOnly={!option.isEditable}
              animation="fade"
              tabIndex={this.props.tabIndex}
              popupPosition="bottom center"
              autoFocus={option.setFocus}
              closable
              placeholder={option.placeHolder}
              autoComplete="off"
              error={error}
            />
            { this.renderError() }
          </>
        )

      case 4: // Multi
        return <h1>Multi</h1>

      case 5: // Datetime
        return (
          <Form.Field error={error}>
            <DateTimeInput
              className="ui input"
              name="startDate"
              fluid
              value={Option.getValue(option)}
              iconPosition="left"
              onChange={(event, {value}) => this.handleTextChange(value)}
              autoFocus={option.setFocus}
              readOnly={!option.isEditable}
              tabIndex={this.props.tabIndex}
              animation="fade"
              popupPosition="bottom center"
              closable
              autoComplete="off"
              error={error}
            />
            { this.renderError() }
         </Form.Field>
        )
      case 6: // Money
        return (
          <Form.Field error={error}>
            <Input
              fluid
              icon='pound'
              iconPosition='left'
              type="text"
              autoFocus={option.setFocus}
              onFocus={this.handleMoneyFocus}
              onChange={(event, {value}) => this.handleMoneyChange(value)}
              onBlur={this.handleMoneyBlur}
              value={Option.getValue(option)}
              tabIndex={this.props.tabIndex}
              readOnly={!option.isEditable}
              error={error}
            />
            {this.renderError()}
          </Form.Field>
        )

      case 7: // Int
        return (
          <Form.Field error={error}>
            <Input 
              fluid
              value={Option.getValue(option)}
              onChange={(event, {value}) => this.handleTextChange(value)}
              onFocus={(e) => e.target.select()}
              autoFocus={option.setFocus}
              tabIndex={this.props.tabIndex}
              readOnly={!option.isEditable}
              type="number"
              error={error}
            />
            { this.renderError() }
          </Form.Field>
        )

      case 8: // switch
        return <Checkbox error={error} toggle checked={Option.getValue(option).toLowerCase() === "true"} onChange={() => this.handleCheckboxChange(option)} disabled={!option.isEditable} />

      case 9:
        const background = getBackgroundColour(option)
        const color = getTextColour(option);
        return background !== "transparent" ? <Label style={{background, color, float: "right", "min-width": "90px", "text-align": "center" }}>{option.defaultText}</Label> : <span>{option.defaultText}</span>

      case 10: // checkbox
        return <Checkbox error={error} checked={Option.getValue(option).toLowerCase() === "true"} onChange={() => this.handleCheckboxChange(option)} disabled={!option.isEditable} label={option.text} />

      case 11:
        return <Form.Field error={error}>
          <TextArea 
            autoFocus={option.setFocus}
            onChange={(event, {value}) => this.handleTextChange(value)} 
            className="w-100" 
            disabled={!option.isEditable}
            fluid 
            rows={4} 
            value={option.defaultText} 
            tabIndex={this.props.tabIndex}
          />
        </Form.Field>

      case 12:
        return <Icon name={option.defaultText} />

      case 13:
        let total = 0;
        option.data.forEach(item => {
          const field = this.props.optionsList.find(x => x.code === item.id)
          if (field) {
            const value = parseFloat(uglyMoney(Option.getValue(field)) || 0)
            switch (item.text) { // signage
              case "+":
                total += value;
                break;
              
              case "-":
                total -= value;
                break;

              case "*":
                total *= value;
                break;

              case "/":
                total /= value;
                break;
              
              default:
                break;
            } 
          }
          
        })
       
        total = option.isCurrency ? `£${parseFloat(total).toFixed(2) || 0}` : parseInt(total) || 0;

        return <span>{total}</span>


      default:
        return <span>{option.defaultText}</span>

    }
   
  }
};

export default Option;
